module.exports = __webpack_public_path__ + "img/chart.70e20a0b.svg";